import { connect } from 'react-redux';
import App from '../components/App.js';

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(null, mapDispatchToProps)(App);



/** WEBPACK FOOTER **
 ** ./src/containers/AppContainer.js
 **/